const rpcUrl = 'https://rpc.blaze.soniclabs.com',
    blockExplorers = 'https://blaze.soniclabs.com'
export default {
    id: 57054,
    name: 'Sonic Blaze Testnet',
    network: 'sonic-blaze-testnet',
    nativeCurrency: {name: 'Sonic', symbol: 'S', decimals: 18},
    rpcUrls: {
        default: {
            http: [rpcUrl],
        },
        public: {
            http: [rpcUrl],
        },
    },
    blockExplorers: {
        etherscan: {name: 'SonicBlazetestnet', url: blockExplorers},
        default: {name: 'Sonic Blaze Testnet Explorer', url: blockExplorers},
    },
    contracts: {},
}